import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { graphql, compose, withApollo } from 'react-apollo';
import { withRouter } from 'react-router-dom';
import Renew from '../../components/Renew';
import renewMember from '../../mutations/renewMember';
import standardizeAddress from '../../queries/standardizeAddress';
import getEncryptData from '../../queries/getEncryptedData';
import sendEmailToMember from '../../queries/sendEmailToMember';
import {
  setSuccessMessage,
  setErrorMessage,
  setPaymentRequest,
  removePaymentResponse,
  setMemberRequest,
  removeMemberRequest,
} from '../../actions';

const validateAddress = client => (
  ({ addressLine1, addressLine2, city, state, zipCode, country }) => (
    client.query({
      query: standardizeAddress,
      variables: {
        input: { addressLine1, addressLine2, city, state, zipCode, country },
      },
      fetchPolicy: 'network-only',
    })
  )
);

const encryptData = client => (
  ({ data, saltName }) => (
    client.query({
      query: getEncryptData,
      variables: {
        input: { data, saltName },
      },
      fetchPolicy: 'network-only',
    })
  )
);

const sendEmail = client => (
  ({ fromEmailAddress, toEmailAddress, subject, htmlBody }) => (
    client.query({
      query: sendEmailToMember,
      variables: {
        input: { fromEmailAddress, toEmailAddress, subject, htmlBody },
      },
      fetchPolicy: 'network-only',
    })
  )
);


export const mapStateToProps = ({ paymentResponse, memberRequest }) => ({
  paymentResponse,
  memberRequest,
});

export const RenewWrapper = props => (
  <Renew
    validateAddress={validateAddress(props.client)}
    encryptData={encryptData(props.client)}
    sendEmail={sendEmail(props.client)}
    {...props}
  />
);

RenewWrapper.propTypes = {
  client: PropTypes.object.isRequired,
};

export default compose(
  graphql(renewMember, {
    name: 'renewMember',
    options: { notifyOnNetworkStatusChange: true },
  }),
)(withRouter(connect(mapStateToProps, {
  setMemberRequest,
  removeMemberRequest,
  setSuccessMessage,
  setErrorMessage,
  setPaymentRequest,
  removePaymentResponse,
})(withApollo(RenewWrapper))));



// WEBPACK FOOTER //
// ./src/app/containers/Renew/index.js